import React, { useEffect } from "react";

import FirstSection from "./FirstSection";
import SecondSection from "./SecondSection";
import ThirdSection from "./ThirdSection";
import FourthSection from "./FourthSection";
import FifthSection from "./FifthSection";
import SixthSection from "./SixthSection";
import SeventhSection from "./SeventhSection";

const Home = () => {

  return (
    <div id="main" className="mt-0 mb-0 z-20 relative">
      <FirstSection />
      <SecondSection />
      <ThirdSection />
      {/* <FourthSection /> */}
      {/* <FifthSection /> */}
      <SixthSection />
      <SeventhSection />
    </div>
  );
};

export default Home;
